export default __webpack_public_path__ + "static/media/shopIcon.353e9e9d.png";